module.exports = __webpack_public_path__ + "img/24.dd349ff9.jpg";